import React, { CSSProperties, ReactNode } from "react";

import styles from "./sub-header.module.scss";

interface SubHeaderPropTypes {
  children: ReactNode;
  variant?: string | string[];
  /** Optional explicit background override (any valid CSS
   *  `background` shorthand / `background-color`). When passed
   *  it wins over the SCSS `--color-cp-subheader-bg` cascade and
   *  its fallback. Tests use this to assert what is painted
   *  without having to mutate SCSS variables in JSDOM. */
  background?: CSSProperties["background"];
}

export const SubHeader = ({
  children,
  variant,
  background,
}: SubHeaderPropTypes) => {
  let variantClass = "";

  if (typeof variant === "string") {
    variantClass = styles[`sub-header--${variant}`];
  } else if (Array.isArray(variant)) {
    variantClass = variant.map((v) => styles[`sub-header--${v}`]).join(" ");
  }
  return (
    <div
      className={`${styles["sub-header"]} ${variantClass}`}
      style={background !== undefined ? { background } : undefined}
    >
      {children}
    </div>
  );
};
